export function getInfoValue(json: string): string {
  try {
    return json.replace("[", "").replace("]", "");
  } catch (error) {
    return json;
  }
}
